import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { UlipService } from '../../services/Ulip/ulip.service';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { appService } from '../../../../app/_services/app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-ulip',
  templateUrl: './new-ulip.component.html',
  styleUrls: ['./new-ulip.component.scss']
})
// Added by priya - 20/01/2026 - common component for display vehicle and driver ulip data - cn(PRIYA-JAN26-013)
export class NewUlipComponent implements OnInit {

  @Input() LicenseNo: any;
  @Input() Dob: any;
  @Input() VehicleNo: any;
  @Input() IsShowDriver: boolean = false; // Added by priya - 21/01/2026 - cn(PRIYA-JAN26-013)
  @Input() IsShowVehicle: boolean = false; // Added by priya - 21/01/2026 - cn(PRIYA-JAN26-013)
  SarathiData: any = {}
  VahanData: any = {}
  userId: any; // Added by priya - 30/03/2026 - cn(PRIYA-MAR26-015)
  @Input() VehicleTypeId: any; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  VehicleWeight: any; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  isWeightMismatch: boolean = false; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  IsVahanRegValidity: boolean = false; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  IsVahanFitValidity: boolean = false; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  IsVahanTaxValidity: boolean = false; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  IsVahanInsuranceValidity: boolean = false; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  IsVahanPUCValidity: boolean = false; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  IsVahanWeightMismatchValidity: boolean = false; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  IsSarathiLicenseValidity: boolean = false; // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)

  constructor(
    private Ulip: UlipService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private _appService: appService,
    private toastr: ToastrService,
  ) { }

  async ngOnInit() {
    // Added by priya - 30/03/2026 - cn(PRIYA-MAR26-015)
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const settings = [
      { name: 'CheckVahanRegistrationValidity', flag: 'IsVahanRegValidity' },
      { name: 'CheckVahanFitValidity', flag: 'IsVahanFitValidity' },
      { name: 'CheckVahanTaxValidity', flag: 'IsVahanTaxValidity' },
      { name: 'CheckVahanInsuranceValidity', flag: 'IsVahanInsuranceValidity' },
      { name: 'CheckVahanPUCValidity', flag: 'IsVahanPUCValidity' },
      { name: 'CheckVahanWeightMismatchValidity', flag: 'IsVahanWeightMismatchValidity' },
      { name: 'CheckSarathiLicenseValidity', flag: 'IsSarathiLicenseValidity' }
    ];
    for (const s of settings) {
      await this.fetchSystemSetting(s.name, s.flag);
    }
    // Call APIs after all flags are ready
    if (this.VehicleNo) await this.GetVehicleUlipData(this.VehicleNo);
    if (this.LicenseNo && this.Dob) await this.GetDriverUlipData(this.LicenseNo);
    // settings.forEach(s => this.fetchSystemSetting(s.name, s.flag));
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes', changes)
    // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
    if (changes['VehicleTypeId']) {
      this.GetVehicleDetailById(this.VehicleTypeId);
    }
    // End by priya
    if (changes['LicenseNo']) {
      this.LicenseNo = changes['LicenseNo'].currentValue;
    }
    if (changes['Dob']) {
      this.Dob = changes['Dob'].currentValue;
    }
    if (this.LicenseNo && this.Dob) {
      this.GetDriverUlipData(this.LicenseNo);
    }
    if (changes['VehicleNo']) {
      this.VehicleNo = changes['VehicleNo'].currentValue;
      if (this.VehicleNo) {
        this.GetVehicleUlipData(this.VehicleNo)
      }
    }
  }

  GetDriverUlipData(LicenseNo): Promise<void>{
    if (!LicenseNo || !this.Dob) return Promise.resolve();
    return this.Ulip.GetDriverUlipData(LicenseNo).then(res => {
      this.SarathiData = res && res.length > 0 ? res[0] : null;
      if (!this.SarathiData) return this.ValidateDriverUlip();
    }).catch(err => console.log(err));
  }

  GetVehicleUlipData(VehicleNo): Promise<void>{
    if (!VehicleNo) return Promise.resolve();
    return this.Ulip.GetVehicleUlipData(VehicleNo).then(res => {
      this.VahanData = res && res.length > 0 ? res[0] : null;
      if (this.IsVahanWeightMismatchValidity){
        this.checkWeightMismatch();
      } else {
        this.isWeightMismatch = false;
      }
      if (!this.VahanData) return this.ValidateVehicleUlip();
    }).catch(err => console.log(err));
  }

  reloadData(licenseNo, vehicleNo) {
    console.log('calling')
    if (licenseNo) this.GetDriverUlipData(licenseNo);
    if (vehicleNo) this.GetVehicleUlipData(vehicleNo);
  }

  // Added by priya - 30/03/2026 - cn(PRIYA-MAR26-015)
  ValidateVehicleUlip(){
    if(!this.VehicleNo) return;
    return this.Ulip.ValidateVehicleUlip(this.VehicleNo).then(res => {
      // this.VahanData = res.vahanData;
      if (res.vahanData && Object.keys(res.vahanData).length > 0) {
        this.GetVehicleUlipData(this.VehicleNo)
      }
    }).catch(err => {
      return Promise.resolve();
    });
  }

  // Added by priya - 30/03/2026 - cn(PRIYA-MAR26-015)
  ValidateDriverUlip(){
    var licenseNo = this.LicenseNo;
    var dob = this.Dob;
    if(!licenseNo || !dob) return;
    return this.Ulip.ValidateDriverUlip(licenseNo, dob).then(res => {
      if (res.sarathiData && Object.keys(res.sarathiData).length > 0)
      this.GetDriverUlipData(licenseNo);
    }).catch(err => {
      return Promise.resolve();
    });
  }

  // Added by priya - 30/03/2026 - cn(PRIYA-MAR26-015)
  isExpired(value: string): boolean {
    // return value.toLowerCase().includes('expired');
    if (!value) return false;
    return value.toLowerCase().indexOf('expired') > -1;
  }

  // Added by priya - 30/03/2026 - cn(PRIYA-MAR26-015)
  isSectionExpired(days: string, flag: boolean): boolean {
    return flag && days != null && days.toLowerCase().indexOf('expired') > -1; // works for both number or string converted to number
  }

  hasVahanExpired(): boolean {
    if (!this.VehicleNo || !this.VahanData) return false;
    const sections = [
      { days: this.VahanData.RegLeftDays, flag: this.IsVahanRegValidity },
      { days: this.VahanData.VehicleFitLeftDays, flag: this.IsVahanFitValidity },
      { days: this.VahanData.VehicleTaxLeftDays, flag: this.IsVahanTaxValidity },
      { days: this.VahanData.VehicleInsuranceLeftDays, flag: this.IsVahanInsuranceValidity },
      { days: this.VahanData.VehiclePUCLeftDays, flag: this.IsVahanPUCValidity },
    ];

    return sections.some(s => this.isSectionExpired(s.days, s.flag));
  }

  // Added by priya - 30/03/2026 - cn(PRIYA-MAR26-015)
  hasDriverExpired(): boolean {
    if (!this.LicenseNo) return false;
    if (!this.SarathiData || Object.keys(this.SarathiData).length === 0) return true;
    const sections = [
      { days: this.SarathiData.DlValidityDays, flag: this.IsSarathiLicenseValidity },
    ]
    sections.some(s => this.isSectionExpired(s.days, s.flag));
    // return this.isExpired(this.SarathiData.DlValidityDays)
    //   || this.SarathiData.DlStatus !== 'Active';
  }

  hasAnyExpired(): boolean {
    return this.hasVahanExpired() || this.hasDriverExpired();
  }

  // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  GetVehicleDetailById(VehicleId){
    console.log(VehicleId)
    if(VehicleId == null) return;
    this._appService.GetById("VehicleMaster", "GetVehicleDetailById", VehicleId).subscribe(
      (response) => {
        if (response) {
          this.VehicleWeight = response[0].VehicleWeight;
          this.checkWeightMismatch();
        }
      },
      (err) => {
        console.log('error occuring')
      }
    );
  }

  // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
  checkWeightMismatch() {
    // if (this.IsVahanWeightMismatchValidity){
      if (this.VahanData && this.VehicleWeight) {
        const vahanWeight = Number(this.VahanData.RegVehicleGrossWeight);
        const masterWeight = Number(this.VehicleWeight);
        const HigherMasterWeight = masterWeight * 1.10;
        // Check if Vahan weight is 10% greater
        if (vahanWeight < HigherMasterWeight) {
          this.isWeightMismatch = true;
        } else {
          this.isWeightMismatch = false;
        }
      }
    // } else {
    //   this.isWeightMismatch = false;
    // }
  }

  private fetchSystemSetting(settingName: string, targetFlag: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this._appService.GetById("Common", "GetSystemSettingByName", settingName)
        .subscribe(
          (response) => {
            this[targetFlag] = (response === '1');
            resolve();
          },
          (err) => reject(err)
        );
    });
  }

}
